import { render, staticRenderFns } from "./skuRule.vue?vue&type=template&id=0d58f118&scoped=true"
var script = {}
import style0 from "./skuRule.vue?vue&type=style&index=0&id=0d58f118&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d58f118",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d58f118')) {
      api.createRecord('0d58f118', component.options)
    } else {
      api.reload('0d58f118', component.options)
    }
    module.hot.accept("./skuRule.vue?vue&type=template&id=0d58f118&scoped=true", function () {
      api.rerender('0d58f118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/goods/csg/sku/components/skuRule.vue"
export default component.exports